/* JOEKR Luxury PDP (P5) — FLIPズーム + バリアント切替 + カート */
(() => {
  const pdps = document.querySelectorAll('.jpdp');
  if (!pdps.length) return;

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  pdps.forEach(pdp => {
    // ---------- バリアント切替 ----------
    const form = pdp.querySelector('.jpdp__form');
    if (form && window.__product_data__) {
      const inputs = form.querySelectorAll('.jpdp__variant-input');
      const variantIdInput = form.querySelector('.jpdp__variant-id');
      const priceEl = pdp.querySelector('.jpdp__price');
      const cartLabel = pdp.querySelector('.jpdp__cart-btn-label');
      const cartBtn = pdp.querySelector('.jpdp__cart-btn');
      function selectedOptions() {
        const opts = [];
        inputs.forEach(i => {
          if (i.checked) opts[parseInt(i.dataset.optionIndex, 10)] = i.value;
        });
        return opts;
      }
      function findVariant() {
        const opts = selectedOptions();
        return window.__product_data__.variants.find(v =>
          v.options.every((o, i) => o === opts[i])
        );
      }
      inputs.forEach(i => i.addEventListener('change', () => {
        const v = findVariant();
        if (!v) return;
        variantIdInput.value = v.id;
        if (priceEl && v.price != null) {
          priceEl.textContent = '¥' + (v.price / 100).toLocaleString('ja-JP');
        }
        if (cartLabel && cartBtn) {
          if (v.available) {
            cartLabel.textContent = 'Add to Cart';
            cartBtn.disabled = false;
          } else {
            cartLabel.textContent = 'Sold Out';
            cartBtn.disabled = true;
          }
        }
      }));
    }

    // ---------- AJAX カート追加 ----------
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (!window.fetch) return; // フォールバックは通常のPOST
        e.preventDefault();
        const fd = new FormData(form);
        const btn = form.querySelector('.jpdp__cart-btn');
        const lbl = btn?.querySelector('.jpdp__cart-btn-label');
        const orig = lbl?.textContent;
        if (btn) btn.disabled = true;
        if (lbl) lbl.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error('cart add failed');
          if (lbl) lbl.textContent = 'Added ✓';
          window.dispatchEvent(new CustomEvent('cart:added'));
          // Open cart drawer if Dawn provides one
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
          setTimeout(() => {
            if (lbl) lbl.textContent = orig || 'Add to Cart';
            if (btn) btn.disabled = false;
          }, 1600);
        } catch (err) {
          if (lbl) lbl.textContent = orig || 'Add to Cart';
          if (btn) btn.disabled = false;
          form.submit(); // フォールバック: 通常POST
        }
      });
    }

    // ---------- FLIP ズーム ----------
    const lightbox = pdp.querySelector('.jpdp__lightbox');
    const lbInner = lightbox?.querySelector('.jpdp__lightbox-inner');
    const closeBtn = lightbox?.querySelector('.jpdp__lightbox-close');
    if (!lightbox || !lbInner) return;

    const triggers = pdp.querySelectorAll('[data-flip-trigger]');
    let openTrigger = null;

    function openZoom(btn) {
      if (reduceMotion) return openZoomSimple(btn);
      const img = btn.querySelector('img');
      if (!img) return;
      const url = btn.dataset.imageUrl || img.src;
      const alt = btn.dataset.imageAlt || img.alt;
      const startRect = img.getBoundingClientRect();

      // 1. lightbox にターゲットを配置（最終位置）
      lbInner.innerHTML = '';
      const clone = document.createElement('img');
      clone.src = url;
      clone.alt = alt;
      clone.style.opacity = '0';
      lbInner.appendChild(clone);
      lightbox.setAttribute('aria-hidden', 'false');
      openTrigger = btn;

      // 2. ライトボックス内のターゲット位置を計測
      clone.onload = () => {
        const endRect = clone.getBoundingClientRect();
        // 3. FLIP: ターゲットを開始位置に瞬時に移動
        const dx = startRect.left - endRect.left;
        const dy = startRect.top - endRect.top;
        const sx = startRect.width / endRect.width;
        const sy = startRect.height / endRect.height;
        clone.style.transformOrigin = 'top left';
        clone.style.transform = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
        clone.style.transition = 'none';
        clone.style.opacity = '1';
        // 4. 次フレームで最終位置にアニメ
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            clone.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
            clone.style.transform = 'none';
          });
        });
      };
      // src が cached の場合
      if (clone.complete) clone.onload();
      document.body.style.overflow = 'hidden';
    }

    function openZoomSimple(btn) {
      const url = btn.dataset.imageUrl;
      const alt = btn.dataset.imageAlt || '';
      lbInner.innerHTML = `<img src="${url}" alt="${alt.replace(/"/g, '&quot;')}" />`;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      openTrigger = btn;
    }

    function closeZoom() {
      if (reduceMotion || !openTrigger) {
        lightbox.setAttribute('aria-hidden', 'true');
        lbInner.innerHTML = '';
        document.body.style.overflow = '';
        openTrigger = null;
        return;
      }
      const clone = lbInner.querySelector('img');
      const startRect = openTrigger.querySelector('img')?.getBoundingClientRect();
      const endRect = clone?.getBoundingClientRect();
      if (clone && startRect && endRect) {
        const dx = startRect.left - endRect.left;
        const dy = startRect.top - endRect.top;
        const sx = startRect.width / endRect.width;
        const sy = startRect.height / endRect.height;
        clone.style.transformOrigin = 'top left';
        clone.style.transition = 'transform 0.45s cubic-bezier(0.4, 0, 1, 1), opacity 0.45s ease';
        clone.style.transform = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
        clone.style.opacity = '0';
        lightbox.style.transition = 'background 0.45s ease';
        lightbox.style.background = 'rgba(14,14,14,0)';
        setTimeout(() => {
          lightbox.setAttribute('aria-hidden', 'true');
          lbInner.innerHTML = '';
          lightbox.style.background = '';
          lightbox.style.transition = '';
          document.body.style.overflow = '';
          openTrigger = null;
        }, 460);
      } else {
        lightbox.setAttribute('aria-hidden', 'true');
        lbInner.innerHTML = '';
        document.body.style.overflow = '';
        openTrigger = null;
      }
    }

    triggers.forEach(b => b.addEventListener('click', () => openZoom(b)));
    closeBtn?.addEventListener('click', closeZoom);
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeZoom();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') closeZoom();
    });

    // ---------- Reveal observer (jhero-globalが拾わない場合の保険) ----------
    if (!reduceMotion) {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      pdp.querySelectorAll('.j-reveal').forEach(el => io.observe(el));
    }
  });
})();
